import { request } from "./request";

export function listHospitalsByCodes(data) {
  return request("/chair/listHospitalsByCodes", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      hospitalCode: String(data.hospitalCode ?? "").trim(),
      hospitalName: String(data.hospitalName ?? "").trim(),
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 5,
    },
  });
}

export function listAllHospitals(data) {
  return request("/hospital/listAllHospitals", {
    method: "POST",
    body: {
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 10,
      hospitalCode: String(data.hospitalCode ?? "").trim(),
      hospitalName: String(data.hospitalName ?? "").trim(),
    },
  });
}

export function addHospital(data) {
  return request("/hospital/addHospital", {
    method: "POST",
    body: {
      hospitalCode: String(data.hospitalCode ?? "").trim(),
      hospitalName: String(data.hospitalName ?? "").trim(),
      address: String(data.address ?? "").trim(),
      longitude: data.longitude,
      latitude: data.latitude,
      areaName: String(data.areaName ?? "").trim(),
      regional: String(data.regional ?? "").trim(),
    },
  });
}

export function updateHospital(data) {
  return request("/hospital/updateHospital", {
    method: "POST",
    body: {
      hospitalId: String(data.hospitalId),
      hospitalCode: String(data.hospitalCode ?? "").trim(),
      hospitalName: String(data.hospitalName ?? "").trim(),
      address: String(data.address ?? "").trim(),
      longitude: data.longitude,
      latitude: data.latitude,
      areaName: String(data.areaName ?? "").trim(),
      regional: String(data.regional ?? "").trim(),
    },
  });
}

/** 删除医院 */
export function deleteHospital(data) {
  return request("/hospital/deleteHospital", {
    method: "POST",
    body: {
      hospitalId: String(data.hospitalId),
    },
  });
}